import TooltipWrapper from "views/uikit/TooltipWrapper";
import { BiInfoCircle } from "react-icons/bi";
import { ReactNode } from "react";

import styles from "./styles.module.scss";
import classNames from "classnames";

const QUERY_TITLE_TOOLTIP_ID = "query-title-tooltip";

interface QueryModalTitleProps {
  info?: string;
  icon: ReactNode;
  children: ReactNode;
}

export default function QueryModalTitle({
  icon,
  info,
  children,
}: QueryModalTitleProps) {
  return (
    <div className={styles.queryModalTitle}>
      <div
        className={classNames(styles.icon, "queryModalTitleIcon")}
        data-testid="query-modal-title-icon"
      >
        {icon}
      </div>
      <span
        className={classNames(
          styles.queryModalTitleContainer,
          "queryModalTitleContainer",
        )}
      >
        {children}
      </span>
      {info && (
        <span
          className={classNames(styles.info, "queryModalInfo")}
          data-tooltip-content={info}
          data-tooltip-id={QUERY_TITLE_TOOLTIP_ID}
        >
          <BiInfoCircle />
          <TooltipWrapper id={QUERY_TITLE_TOOLTIP_ID} maxWidth="320px" />
        </span>
      )}
    </div>
  );
}
